module.exports = __webpack_public_path__ + "static/media/29ADMSPC12.dfb8fd92.jpg";